import { useCallback, useEffect, useState } from "react";
import "../App.css";
import "../styles/booking.scss";
import Calendar from "../components/Calendar";
import Persons from "../components/Persons";
import ActiveBookings from "../components/ActiveBookings";
import { buildApiUrl } from "../config/api";

import { USER_1_KOKORIN } from "../config/trainers";
export { USER_1_KOKORIN, USER_2_KOROVCHENO, USERS } from "../config/trainers";

function Home() {
  const [selectedTimes, setSelectedDateTimes] = useState({});
  const [currentUser, serCurrentUser] = useState(USER_1_KOKORIN.id);
  const [bookingRefreshSignal, setBookingRefreshSignal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const refreshTime = useCallback(async () => {
    try {
      const res = await fetch(buildApiUrl("/api/bookings/available-slots-all"));
      if (!res.ok) throw new Error("schedule");
      setSelectedDateTimes(await res.json());
      setError("");
    } catch {
      setError("Не вдалося завантажити розклад. Спробуйте ще раз.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refreshTime(); }, [refreshTime]);

  return (
    <div className="App home booking-home">
      <header className="studio-header">
        <a className="studio-brand" href="/" aria-label="Dance Sfera — головна">
          <span className="studio-symbol" aria-hidden="true">s</span>
          <span>dance<span className="brand-light">sfera</span><small>ПРОСТІР ТВОГО РУХУ</small></span>
        </a>
        <span className="studio-header-note"><i aria-hidden="true" /> Онлайн-запис відкрито</span>
      </header>
      <main>
        <section className="studio-intro">
          <div><p className="studio-eyebrow">ТВІЙ ЧАС. ТВІЙ РИТМ.</p><h1>Знайди час <em>для себе.</em></h1></div>
          <p className="studio-intro-copy">Улюблений тренер, зручний час і ще один крок до себе. Запишись на індивідуальне заняття.</p>
        </section>
        <div className="booking-layout">
          <Persons serCurrentUser={serCurrentUser} currentUser={currentUser} />
          <Calendar refreshTime={refreshTime} selectedTimes={selectedTimes} currentUser={currentUser}
            loading={loading} error={error} onBooked={() => setBookingRefreshSignal((s) => s + 1)} />
        </div>
        <ActiveBookings refreshSignal={bookingRefreshSignal} onCancelled={refreshTime} />
      </main>
      <footer className="studio-footer"><span>Dance Sfera</span><span>Місце, де починається твій рух.</span><span>Київ · Україна</span></footer>
    </div>
  );
}
export default Home;
